var map = {
	"./4star.svg": 5566,
	"./6star.svg": 7788,
	"./7star.svg": 5689,
	"./arrow.svg": 7285,
	"./bag.svg": 4356,
	"./bear.svg": 8112,
	"./bird.svg": 2815,
	"./bow.svg": 1442,
	"./bubbles.svg": 727,
	"./cake.svg": 1642,
	"./cloud.svg": 7693,
	"./croissant.svg": 4418,
	"./cross.svg": 7190,
	"./drink.svg": 532,
	"./flower.svg": 8235,
	"./flower2.svg": 8995,
	"./flower3.svg": 1058,
	"./glasses.svg": 2306,
	"./heart.svg": 6954,
	"./hearts.svg": 1381,
	"./leftstar.svg": 3657,
	"./orange.svg": 1348,
	"./pancake.svg": 6127,
	"./star_menu.svg": 2632,
	"./sun.svg": 44,
	"./weights.svg": 1841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8330;